import {Component, Input, OnInit} from '@angular/core';
import {StudentsService} from '../../../../../services/students/students.service';

@Component({
  selector: 'app-profile-summary',
  templateUrl: './profile-summary.component.html',
  styleUrls: ['./profile-summary.component.scss']
})
export class ProfileSummaryComponent implements OnInit {

  @Input() thumbnailPhotoUrl;
  @Input() name;
  @Input() email;
  @Input() ouPath;
  constructor() {

  }

  ngOnInit(): void {
    // console.log(this.thumbnailPhotoUrl);
  }

  getDefaultPhotoUrl(): string {
    return this.thumbnailPhotoUrl || StudentsService.defaultPhotoUrl;
  }
}
